import React from "react";


function Footer() {
    var year = (new Date()).getFullYear().toString()
    return (
        <div id="footer" className="bg-blue-900 text-white flex flex-col text-center md:text-left md:flex-row py-5 px-3 font-semibold">
            <h6>© {year} Bottle Depot</h6>
            <div className="md:w-0.5 w-9/10 h-0.5 self-center my-3 md:my-0 md:mx-2 bg-white"></div>
            <div><h6>Site Created By Tejpaul Singh</h6></div>
        </div>
    )
}

export default Footer
